import Button from '@mui/material/Button';
import icon from '@/icons/logos/metamask_logo.svg';
import styles from './metamask-button.module.css';

export default function MetaMaskButton({
  onClick,
  children,
  disabled,
  color = 'primary',
  fullWidth = true,
}) {
  return (
    <Button
      variant="metaMask"
      color={color}
      data-core-qa="metamaskButton"
      onClick={onClick}
      disabled={disabled}
      startIcon={<img src={icon.src} alt="metamask logo" />}
      fullWidth={fullWidth}
    >
      <div className={styles.children}>{children}</div>
    </Button>
  );
}
